import { Link } from "react-router-dom";

export function ReportContextSummary({
  studentName,
  assessmentLabels,
  changeTo
}: {
  studentName: string;
  assessmentLabels: string[];
  changeTo?: string;
}): JSX.Element {
  return (
    <section
      aria-label="报告范围"
      className="flex flex-col gap-4 rounded-xl border border-brand/20 bg-brand/5 p-5 lg:flex-row lg:items-center"
    >
      <div className="min-w-0 lg:w-56">
        <p className="text-xs font-semibold text-slate-500">儿童</p>
        <p className="mt-1 font-semibold text-slate-800">{studentName}</p>
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-xs font-semibold text-slate-500">
          {assessmentLabels.length > 1 ? `评估记录（${assessmentLabels.length} 份）` : "评估记录"}
        </p>
        <p className="mt-1 text-sm text-slate-700">{assessmentLabels.join("、")}</p>
      </div>
      {changeTo ? (
        <Link
          to={changeTo}
          className="inline-flex min-h-11 shrink-0 items-center justify-center self-start rounded-md border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-600 transition hover:border-brand hover:text-brand focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/40 lg:self-auto"
        >
          重新选择
        </Link>
      ) : null}
    </section>
  );
}
